import api from "../../index.js";
import { qs } from "../../../utils/utils.js";

export const GetIBTeamApi = (params) => api.get(`ibusermaster/get-ibteam-details?${qs(params)}`);
export const GetUserDetailsByIdApi = (userId) => api.get(`admin/getsingle-user-details-ib-team/${userId}`);